import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
import { PageTransition } from '../components/PageTransition';
export function AboutPage() {
  return <PageTransition data-id="element-185" data-mp="55tqf6f1qrj0">
      <div className="pt-24 pb-16 min-h-screen" data-id="element-186" data-mp="550k26k0241e">
        {/* Hero */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-16" data-id="element-187" data-mp="6qlrn2zanbk">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="text-center" data-id="element-188" data-mp="6gxq51huq8i">
            <h1 className="text-4xl md:text-6xl font-serif font-bold text-white mb-6" data-id="element-189" data-mp="3ic2d3qayjgzu">
              Meet Your Host
            </h1>
            <div className="w-24 h-1 bg-gold-500 mx-auto rounded-full" data-id="element-190" data-mp="3deka0gjmfvzr"></div>
          </motion.div>
        </div>

        {/* Main Content */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-191" data-mp="1gimhsg3xddyj">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-192" data-mp="1bmfbgm7ma0g2">
            {/* Image Column */}
            <motion.div initial={{
            opacity: 0,
            x: -50
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: 0.2
          }} className="relative" data-id="element-193" data-mp="2euwdnnpcq5e4">
              <div className="aspect-[4/5] rounded-2xl overflow-hidden bg-dark-600 border border-dark-500 relative shadow-2xl" data-id="element-194" data-mp="2ykgjqqe20zig">
                <img src="https://cdn.magicpatterns.com/uploads/bjyhdk9e4QpXAppoNTRkUf/jason-podcast.jpg" alt="Jason Pawloski" className="absolute inset-0 w-full h-full object-cover" data-id="element-195" data-mp="32kqojzq41jvq" />
                {/* Decorative elements */}
                <div className="absolute bottom-0 left-0 right-0 p-8 bg-gradient-to-t from-black/80 to-transparent" data-id="element-196" data-mp="3hi1ak30dq85p">
                  <h3 className="text-2xl font-serif font-bold text-white" data-id="element-197" data-mp="3mbc7ncfe3akf">
                    Jason Pawloski
                  </h3>
                  <p className="text-gold-400" data-id="element-198" data-mp="3w3f35w5w2xgr">Host & Founder</p>
                </div>
              </div>
              {/* Background accent */}
              <div className="absolute -top-4 -left-4 w-full h-full border-2 border-gold-500/20 rounded-2xl -z-10" data-id="element-199" data-mp="3m6k6lit6f754"></div>
            </motion.div>

            {/* Content Column */}
            <motion.div initial={{
            opacity: 0,
            x: 50
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: 0.4
          }} data-id="element-200" data-mp="3d7f9mgx9jlv2">
              <h2 className="text-3xl font-serif font-bold text-white mb-6" data-id="element-201" data-mp="2yij4armlcmy5">
                Heart & Voice
              </h2>
              <div className="space-y-6 text-white/80 text-lg leading-relaxed" data-id="element-202" data-mp="2thv5hjs4f1td">
                <p data-id="element-203" data-mp="2ph2scfg4ocrt">
                  Jason Pawloski is the heart and voice behind 3 Doves Podcast.
                  With a passion for authentic conversation and a deep love for
                  Christ, Jason created this space to share real stories of
                  faith — not the polished, picture-perfect kind, but the messy,
                  beautiful, transformative kind.
                </p>
                <p data-id="element-204" data-mp="1izbcjgo5l4ly">
                  Each week, he sits down with everyday people and
                  Christ-followers to explore what it truly means to walk with
                  God through work, relationships, doubt, growth, and calling.
                  Jason believes that every person has a story worth telling and
                  that God is always at work, even in the quiet moments.
                </p>
              </div>

              <div className="mt-12 p-8 bg-dark-600 rounded-xl border-l-4 border-gold-500 relative" data-id="element-205" data-mp="101if2twatmvy">
                <Quote className="absolute top-4 left-4 w-8 h-8 text-gold-500/20" data-id="element-206" data-mp="2ipc2q0u3zpz" />
                <p className="text-xl font-serif italic text-white relative z-10 pl-6" data-id="element-207" data-mp="7ibpp0kkrhzb">
                  "These are conversations about faith lived out, not cleaned
                  up. About grace in the process, not perfection on display."
                </p>
              </div>
            </motion.div>
          </div>

          {/* Why 3 Doves Section */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="mt-24 bg-dark-800 rounded-2xl p-8 md:p-16 text-center border border-dark-600" data-id="element-208" data-mp="2e7n7gsuezgas">
            <img src="https://cdn.magicpatterns.com/uploads/ue8vBFZwEq6iFGtuLhrkM6/Podcastlogo3doves.jpg" alt="Logo" className="w-20 h-20 rounded-full mx-auto mb-8 border border-gold-500/30" data-id="element-209" data-mp="2wymz61tan47r" />
            <h2 className="text-3xl font-serif font-bold text-white mb-6" data-id="element-210" data-mp="12lx4viz0jszu">
              Why "3 Doves"?
            </h2>
            <p className="text-xl text-white/80 max-w-3xl mx-auto leading-relaxed" data-id="element-211" data-mp="3e8qv70iyk4is">
              The three doves represent the — a reminder that God's presence
              surrounds us in every conversation, every story, and every step of
              faith.
            </p>
          </motion.div>
        </div>
      </div>
    </PageTransition>;
}